const US_LOCALE = 'en-us'
const SUNDAY = 'sunday'
const MONDAY = 'monday'
const WEEKDAYS_INDEX = {
  [SUNDAY]: 0,
  [MONDAY]: 1
}

export default {
  created() {
    this.calendarBeginningOfWeek = MONDAY
    this.calendarBeginningOfWeekIndex = WEEKDAYS_INDEX[MONDAY]
    if (navigator.language.toLowerCase() === US_LOCALE) {
      this.calendarBeginningOfWeek = SUNDAY
      this.calendarBeginningOfWeekIndex = WEEKDAYS_INDEX[SUNDAY]
    }
  }
}
